import React from 'react'
import ApplyStep from './ApplyStep'

const StartYourApplication = () => {
  const url = "https://calendly.com/yard_au"
  return (
    <div>
      You can either click <a href='/onboarding_funnel/new'>Apply now</a> to start your application,
      <a href='javascript:;'><span onClick={ () => Calendly.showPopupWidget(url)}> book a meeting</span></a> or <a href='javascript:;'>
      <span onClick={() => window.HubSpotConversations.widget.open()}>chat with us</span></a> online! No documents are required yet! 
      Just tell us about the property you’re purchasing or refinancing and give us an overview of your income and employment details, assets, liabilities and expenses.
    </div>
  )

}

const ApplyStepsContainer = () => (
  <div>
    <ApplyStep
      step='1'
      header='Start your application'
      body={<StartYourApplication />}
      image='howToApplyStep1'
      direction='right'
    />
    <ApplyStep
      step='2'
      header='Book a meeting'
      body='Everyone has unique circumstances. Your dedicated Loan Consultant will speak with you to confirm your home loan requirements and understand your timeframes for settlement.'
      image='howToApplyStep2'
      direction='left'
    />
    <ApplyStep
      step='3'
      header='Provide your supporting documentation'
      body='Upload your documents through our secure online portal for us to verify your information. We might need things like ID documents, payslips, bank statements or tax returns.'
      image='howToApplyStep3'
      direction='right'
    />
    <ApplyStep
      step='4'
      header='We assess your application'
      body='We submit your application to our credit team for assessment. When all of your details check out, we provide you with the decision on your loan!'
      image='howToApplyStep4'
      direction='left'
    />
    <ApplyStep
      step='5'
      header='Your loan documents'
      body='We send you our loan contract via email. You can sign your documents online. '
      image='howToApplyStep5'
      direction='right'
    />
    <ApplyStep
      step='6'
      header='We settle your loan'
      body='We work with your conveyancer or current lender to settle the loan!'
      image='howToApplyStep6'
      direction='left'
    />
  </div>
);

export default ApplyStepsContainer
